var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _path9, _path10, _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgViewSyncGoogleDrive = function SvgViewSyncGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 206,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 206,
    rx: 8,
    fill: "#1a1a2e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 50L95 95h25l25-45h-25z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145 50l-25 45h25l25-45h-25z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 50l-25 45h50l-25-45z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95 95l25 45h25l-25-45H95z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 95l25 45h25l-25-45h-25z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145 95l25 45h25l-25-45h-25z",
    fill: "#EA4335"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210 95h50",
    stroke: "#4285F4",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250 85l10 10-10 10",
    stroke: "#4285F4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    y: 60,
    width: 50,
    height: 70,
    rx: 4,
    fill: "#2a2a4e",
    stroke: "#4285F4",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 70,
    width: 30,
    height: 4,
    rx: 2,
    fill: "#4285F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 80,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#888"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 90,
    width: 35,
    height: 4,
    rx: 2,
    fill: "#888"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 100,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#888"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 110,
    width: 25,
    height: 4,
    rx: 2,
    fill: "#888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 160,
    r: 15,
    fill: "#2a2a4e",
    stroke: "#34A853",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M293 160a7 7 0 017-7M307 160a7 7 0 01-7 7",
    stroke: "#34A853",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295 156l-2 4-4-2M305 164l2-4 4 2",
    stroke: "#34A853",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 185,
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#888",
    textAnchor: "middle"
  }, "Google Drive to Data Room")));
};

export default SvgViewSyncGoogleDrive;